import {
  FilterBar,
  FilterDateRange,
  FilterMultiSelect,
  FilterSingleSelect,
  FilterTimeRange,
} from "components";
import { ViewReportAccessControl } from "enums";
import React, { useEffect, useMemo } from "react";
import { measureTime } from "services";
import { prettifyIntervalTime } from "services/pretty.service";
import lang from "translations";

const AccessControlReportFilter = ({
  filterState,
  modifyFilter,
  applyFilterCb,
  clearFilterCb,
  accessPointData,
  accessPointLoading,
  guestProfileData,
  guestProfileLoading,
}) => {
  const viewOptions = useMemo(
    () => [
      { value: ViewReportAccessControl.Access, text: lang.accessPoint },
      { value: ViewReportAccessControl.Guest, text: lang.guestProfile },
    ],
    []
  );

  const intervalOptions = useMemo(() => {
    const dateRange = filterState.dateRange;
    let ret = measureTime([dateRange[0], dateRange[1]]).getOptType();
    ret = ret.map((i) => ({
      value: i,
      text: prettifyIntervalTime(i),
    }));
    return ret;
  }, [filterState.dateRange]);

  useEffect(() => {
    modifyFilter("intervalType", { ...intervalOptions[0] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalOptions]);

  return (
    <FilterBar
      className="my-lg"
      onClear={clearFilterCb}
      onApply={applyFilterCb}
      searchBox={false}
      filterState={filterState}
    >
      <FilterDateRange
        id="dateRange"
        label={lang.dateRange}
        maxDays={90}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
      <FilterTimeRange
        id="timeRange"
        label={lang.timeRange}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
      <FilterSingleSelect
        id="viewBy"
        label={lang.viewBy}
        options={viewOptions}
        value={filterState.viewBy}
        onChange={(value) => modifyFilter("viewBy", { value })}
      />
      {filterState.viewBy === ViewReportAccessControl.Access && (
        <FilterMultiSelect
          id="accessPointIds"
          label={lang.accessPoint}
          allLabel={lang.allAccessPoints}
          disableWhenEmpty={false}
          loading={accessPointLoading}
          options={accessPointData}
          value={filterState.accessPointIds}
          onChange={(value) => modifyFilter("accessPointIds", { value })}
        />
      )}
      {filterState.viewBy === ViewReportAccessControl.Guest && (
        <FilterMultiSelect
          id="guestProfileIds"
          label={lang.guestProfile}
          allLabel={lang.allGuestProfiles}
          disableWhenEmpty={false}
          loading={guestProfileLoading}
          options={guestProfileData}
          value={filterState.guestProfileIds}
          onChange={(value) => modifyFilter("guestProfileIds", { value })}
        />
      )}
      <FilterSingleSelect
        id="intervalType"
        label={lang.interval}
        options={intervalOptions}
        value={filterState.intervalType}
        onChange={(value) => modifyFilter("intervalType", { value })}
      />
    </FilterBar>
  );
};

export default AccessControlReportFilter;
